import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { DialogShellComponent } from '../dialog-shell/dialog-shell.component';
import { FilledButtonComponent } from '../../general/button/filled-button/filled-button.component';

export interface AboutDialogData {
  /** Application name, interpolated into the "{name} Portal" title. */
  appName: string;
  /** Free-text description of the company shown below the title. */
  aboutText: string;
  privacyPolicyUrl: string;
  termsUrl: string;
  websiteUrl: string;
}

@Component({
  selector: 'xemex-about-dialog',
  standalone: true,
  imports: [TranslateModule, DialogShellComponent, FilledButtonComponent],
  templateUrl: './about-dialog.component.html',
  styleUrl: './about-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutDialogComponent {
  readonly data = inject<AboutDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef);

  /** Website URL without its protocol, for display. */
  get websiteLabel(): string {
    return this.data.websiteUrl.replace(/^https?:\/\//, '');
  }

  close() {
    this.dialogRef.close();
  }
}
